import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const features = [
  { img: "/images/tokenutility1.webp", title: "Petty Governance" },
  { img: "/images/tokenutility2.webp", title: "Meme Warfare" },
  { img: "/images/tokenutility3.webp", title: "Therapy Dao" },
  { img: "/images/tokenutility4.webp", title: "Heal and Earn" },
  { img: "/images/tokenutility.webp", title: "App Access" },
];

export default function TokenUtility() {
  const [index, setIndex] = useState(0);

  const nextFeature = () => {
    if (index < features.length - 1) setIndex((prev) => prev + 1);
  };

  const prevFeature = () => {
    if (index > 0) setIndex((prev) => prev - 1);
  };

  return (
    <section id="token-utility" className="relative min-h-[50vh] pt-10 pb-10">

      {/* Main Content */}
      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-center gap-6 max-w-6xl mx-auto px-6 py-16">
        
        {/* Token Utility text card */}
        <div className="w-full lg:w-[40%] bg-white border-4 border-black rounded-2xl p-8 shadow-lg text-center lg:text-left">
          <h2
            className="text-3xl lg:text-4xl font-extrabold mb-4 text-black"
            style={{ fontFamily: "Darumadrop One, cursive" }}
          >
            TOKEN UTILITY
          </h2>
          <p
            className="text-gray-800 font-comfortaa text-sm md:text-base font-bold leading-relaxed">
            $FMEX isn’t just another meme coin, it’s a full ecosystem powered by heartbreak, revenge
             energy, and Web3 innovation. Every token gives holders real influence, real perks, and 
             real petty power.
          </p>
        </div>

        {/* Feature Images */}
        <div className="w-full lg:w-[45%] flex flex-col items-center justify-center relative">
          <div className="relative w-full mt-0 md:mt-10 h-[320px] sm:h-[380px] lg:h-[420px] flex items-center justify-center drop-shadow-lg">
            <AnimatePresence mode="wait">
              <motion.img
                key={features[index].img}
                src={features[index].img}
                alt={features[index].title}
                initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                className="h-full object-contain drop-shadow-[0_4px_10px_rgba(0,0,0,0.45)]"
              />
            </AnimatePresence>
          </div>

          {/* Prev/Next buttons — now closer to image */}
          <div className="flex gap-20 mt-0">
            {/* Prev */}
            <div
              onClick={prevFeature}
              className={`cursor-pointer transition-opacity duration-300 ${
                index === 0 ? "opacity-30 pointer-events-none" : "opacity-100"
              }`}
            >
              <img
                src="/images/prevut.png"
                alt="Prev"
                className="w-12 h-12 sm:w-16 sm:h-16 hover:scale-105 transition-transform"
              />
            </div>

            {/* Next */}
            <div
              onClick={nextFeature}
              className={`cursor-pointer transition-opacity duration-300 ${
                index === features.length - 1
                  ? "opacity-30 pointer-events-none"
                  : "opacity-100"
              }`}
            >
              <img
                src="/images/nextvut.png"
                alt="Next"
                className="w-12 h-12 sm:w-16 sm:h-16 hover:scale-105 transition-transform"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
